var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 203c0 112 91 203 203 203s203-91 203-203S315 0 203 0 0 91 0 203zm294 21c3 4 3 9-1 12-3 3-9 3-12-1l-60-74c-1-2-3-3-4-5-4-3-9-5-14-5s-9 2-13 5l-5 5-60 74c-3 4-8 4-12 1-3-3-4-8-1-12l60-74c2-3 5-5 7-7 7-6 16-9 24-9 9 0 17 3 24 9 3 2 5 4 7 7l60 74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircleFilled);
export default __webpack_public_path__ + "static/media/ArrowUpCircleFilled.627442b3030cd2248e488e55f4fb1c21.svg";
export { ForwardRef as ReactComponent };